var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19419 11.4907L8.98451 8.31028L12.7748 5.12982C15.0885 3.1884 18.538 3.49019 20.4794 5.80388C22.4208 8.11757 22.119 11.567 19.8053 13.5084L16.015 16.6889L12.2247 19.8693C9.91099 21.8108 6.46154 21.509 4.52013 19.1953C2.57871 16.8816 2.8805 13.4322 5.19419 11.4907Z",
    stroke: "#6C6D8A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2549 11.3861L13.2432 14.9475",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedications);
export default __webpack_public_path__ + "static/media/medications.83f2772ca1aa29d9073b4062dfa9af3a.svg";
export { ForwardRef as ReactComponent };